<template>
  <vf-input
    :disabled
    :invalid
    :label="$t.customAmount"
    :model-value="maskedPrice"
    :variant
  >
    <span class="flex" :class="{ 'flex-row-reverse': !isCurrencyOnLeft }">
      <span v-if="model">
        {{ currencySymbol }}
      </span>
      <base-input
        ref="inputRef"
        v-model="maskedPrice"
        :class="{ [baseInputClasses]: model }"
        :disabled
        type="text"
        @change="$emit('change', $event)"
      />
    </span>
  </vf-input>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modelValue: string
  currency: string
  placeholder?: string
  disabled?: boolean
  invalid?: boolean
  variant?: 'inverse'
}>()

defineEmits<{
  change: [value: string]
}>()

defineSlots<{
  default?: () => void
}>()

const model = defineModel<string>({ required: true })
const { value: maskedPrice, el: inputRef } = useMask('XXXX', {
  regex: /\d/,
  onUpdate: (v) => model.value = v
})

const { $formatPrice } = useNuxtApp()

const currencySymbol = getCurrencySymbol(useLocale(), props.currency)
const isCurrencyOnLeft = $formatPrice(0, props.currency).toString().startsWith(currencySymbol)

const baseInputClasses = computed(() => isCurrencyOnLeft ? 'pl-1' : 'text-right pr-1')

watch(() => props.modelValue, (newValue) => {
  const formattedValue = newValue ? `${currencySymbol}${newValue}` : ''

  if (formattedValue !== maskedPrice.value)
    maskedPrice.value = formattedValue
}, { immediate: true })
</script>
